export enum CommunicationType {
  CALL = 'CALL',
  MESSAGE = 'MESSAGE',
  MAIL = 'MAIL',
  MAP = 'MAP',
  URL = 'URL',
}
